module.exports = __webpack_public_path__ + "static/media/Cairo-ExtraLight.b24ed6ca.ttf";